module.exports = __webpack_public_path__ + "static/media/addonSearch.aff99158.svg";